export const UserRoles = {
    ReadOnly: {
        id: 'B6ECF43C-FC09-3C58-CFBA-718AFB7D4FF6',
        name: 'Read-Only',
    },
    Capturer: {
        id: 'F82161DC-0439-CCF2-A9CE-8909651FC149',
        name: 'Capturer',
    },
    Champion: {
        id: '1697183C-B105-7C36-3D2E-D6FDA74BE164',
        name: 'Champion',
    },
    Admin: {
        id: '00edafe3-b047-5980-d0fa-da10f400c1e5',
        name: 'Admin',
    },
};

export const RemoteSystems = {
    RDARR: {
        systemId: 1,
        systemName: 'RDARR',
    },
    EWIS: {
        systemId: 2,
        systemName: 'EWIS',
    },
    RiskAppetite: {
        systemId: 3,
        systemName: 'Risk Appetite',
    },
    RiskCulture: {
        systemId: 4,
        systemName: 'Risk Culture',
    },
    IndicatorMicroservice: {
        systemId: 5,
        systemName: 'Indicator Microservice',
    },
};
